import ResetPasswordPage from "./ResetPasswordPage";

const module = {
  routeProps: {
    path: "DownloadUser/ResetPassword",
    component: ResetPasswordPage,
  },
  name: "Download User Reset Password",
  label: "Reset Password",
  title: "Reset Password",
  showOnMenu: false,
};

export default module;
